export function resolveAfter<T>(promise: () => Promise<T>, delay: number) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(promise()), delay);
  });
}
